(ns dashboard.views.analysis.structured-analysis.record-structured-analysis-modal
  (:require ["react" :as react]
            [clojure.set :as set]
            [clojure.string :as str]
            [dashboard.components.expanding-textarea :refer [expanding-textarea]]
            [dashboard.entity.analysis.db :as analysis.db :refer [drop-nth]]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.utils :as utils]
            [dashboard.views.analysis.common :as analysis :refer [is-not-yet-evaluated?]]
            [dashboard.views.analysis.structured-analysis.view-structured-analysis-modal :as-alias view-structured-analysis]
            [re-frame.core :as rf]))

(def -component-id :component/record-structured-analysis-form)

;; TODO: We should probably not allow creation without any states.
;;       Need to figure out how to nicely prompt in the UI, the user to add states
(defn validate [{:keys [construct]}]
  {:construct (some-> construct str/trim str/blank?)})

(defn has-validation-errors [validation-errors]
  (some true? (vals validation-errors)))

(rf/reg-event-fx
 ::create-structured-analysis
 (fn [{:keys [db]} [_ mode]]
   (let [structured-analysis (-> (get-in db [-component-id :data])
                                 ;; remove blank items
                                 (update :excludes #(vec (remove str/blank? %)))
                                 (update :relates-to #(vec (remove str/blank? %))))]
     {:db (assoc-in db [-component-id :is-saving] true)
      :http-xhrio {:method :post
                   :uri (case mode
                          :create "/api/structured-analysis"
                          :edit (str "/api/structured-analysis/analysis/" (:construct-id structured-analysis))
                          nil)
                   :params structured-analysis
                   :format http-config/transit-request-format
                   :response-format http-config/transit-response-format
                   :on-success [::create-structured-analysis-success mode]
                   :on-failure [::create-structured-analysis-failure mode]}})))

(rf/reg-event-fx
 ::create-structured-analysis-success
 (fn [{:keys [db]} [_ mode _]]
   (analysis.db/get-structured-analyses false)
   {:db (assoc-in db [-component-id :is-saving] false)
    :fx [[:dispatch [::ui/pop-modal]]
         [:dispatch [::clear-data]]
         [:dispatch [::notifications/add
                     {:message (case mode
                                 :create "Structured analysis created successfully"
                                 :edit "Structured analysis saved successfully"
                                 nil)}]]]}))

(rf/reg-event-fx
 ::create-structured-analysis-failure
 (fn [{:keys [db]} [_ mode]]
   {:db (assoc-in db [-component-id :is-saving] false)
    :dispatch [::ui/set-error (case mode
                                :create "Failed to create structured analysis"
                                :edit "Failed to save structured analysis"
                                nil)]}))

(rf/reg-event-db
 ::update-data
 (fn [db [_ updates]]
   (update-in db [-component-id :data] merge updates)))

(rf/reg-event-db
 ::clear-data
 (fn [db [_]]
   (update-in db [-component-id] dissoc :data)))

(rf/reg-sub
 ::data
 (fn [db [_]]
   (get-in db [-component-id :data])))

(rf/reg-sub
 ::categories
 (fn [db [_]]
   (get-in db [:categories :data])))

(rf/reg-sub
 ::analysis
 (fn [db [_ construct-id]]
   (some-> (get-in db [:structured-analyses :data construct-id])
           first)))

(rf/reg-sub
 ::analyses
 (fn [db [_]]
   (get-in db [:structured-analyses :data])))

(rf/reg-sub
 ::is-saving
 (fn [db [_]]
   (get-in db [-component-id :is-saving])))

(defn Categories [id->category categories]
  [:div.field.mt-4.pt-2
   [:label.has-text-weight-bold "Analysis categories"]
   [:div.control
    [:div.select.is-multiple
     [:select {:value (map :id categories)
               :on-change (fn [e]
                           (rf/dispatch [::update-data
                                         {:categories
                                          (mapv
                                           (fn [option]
                                             (get id->category (parse-uuid (.-value option))))
                                           (.. e -target -selectedOptions))}]))
               :multiple true
               :size 5}
      (map (fn [{:keys [id name]}]
             [:option {:key (str "category-" id)
                       :value id}
              name])
           (sort-by :name (vals id->category)))]]]])

(defn PossibleStates [{:keys [state-dependencies states parent-id]} parent-analysis]
  [:div.field.mt-4.pt-2
   [:label.has-text-weight-bold "Possible states"]
   [:div.control
    (let [this-state-id->parent-state-id (set/map-invert state-dependencies)]
      (map-indexed
       (fn [index [id name]]
         (let [is-not-yet-evaluated (is-not-yet-evaluated? name)]
          [:div {:key (str "state-" id)}
          [:div.my-1 {:style {:display "flex"
                              :align-items "center"}}
           [:input.input
            {:value name
             :disabled is-not-yet-evaluated
             :on-change #(rf/dispatch [::update-data
                                       {:states (assoc states index [id (.. % -target -value)])}])}]
           (when-not is-not-yet-evaluated
            [:button.button.is-inverted.is-info
            {:title "Remove this state"
             :on-click (fn [_]
                         (rf/dispatch [::update-data
                                       {:states
                                        (vec (remove #(= (first %) id) states))
                                        :state-dependencies
                                        (if-let [parent-state-id (this-state-id->parent-state-id id)]
                                          (dissoc state-dependencies parent-state-id)
                                          state-dependencies)}]))}
            [:span.icon>i.fas.fa-trash]])]
          (when parent-id
            (let [selection (this-state-id->parent-state-id id)]
              [:div.ml-2.mb-4 {:style {:display "flex"
                                       :align-items "center"}}
               [:span
                "Depends on "
                [:b
                 (analysis.profile/format-analysis-id (:construct-id parent-analysis))
                 " "
                 (:construct parent-analysis)]
                " state "]
               [:span.select.ml-2.is-small
                [:select
                 {:value (or selection "no-selection")
                  :on-change (fn [e]
                               (let [selected-state-id (.. e -target -value)]
                                 (rf/dispatch [::update-data
                                               {:state-dependencies
                                                (if (= "no-selection" selected-state-id)
                                                  (dissoc state-dependencies (this-state-id->parent-state-id id))
                                                  (assoc state-dependencies (parse-uuid selected-state-id) id))}])))}
                 [:option {:value "no-selection"}
                  ""]
                 (let [other-states (remove (fn [[state-id _]]
                                              (= id state-id))
                                            states)
                       other-selected-parents (set (keep (fn [[state-id _]]
                                                           (this-state-id->parent-state-id state-id))
                                                         other-states))]
                   (for [[state-id state-name] (:states parent-analysis)
                         :when (not (contains? other-selected-parents state-id))]
                     [:option {:key (str "parent-state-" state-id)
                               :value (str state-id)}
                      state-name]))]]]))]))
                   states))]
   [:div.level.mt-1
    [:div.level-left]
    [:div.level-right>button.button.is-info.is-small.is-rounded
     {:on-click #(rf/dispatch [::update-data {:states (conj states [(random-uuid) ""])}])}
     "Add new state"]]])

(defn ParentSelection [parent-analysis this-id]
  (let [[parent-selection set-parent-selection] (react/useState false)
        [parent-query set-parent-query] (react/useState nil)
        all-analyses @(rf/subscribe [::analyses])]
    [:div.field.mt-4.pt-2
     [:label.has-text-weight-bold "Parent Analysis"]
     (if parent-analysis
       [:div {:style {:display "flex"
                      :align-items "center"}}
        [:div
         (analysis.profile/format-analysis-id (:construct-id parent-analysis))
         [:span.ml-2 (:construct parent-analysis)]]
        [:button.button.is-inverted.is-info
         {:title "Remove dependency"
          :on-click (fn [_]
                      (rf/dispatch [::update-data {:parent-id nil
                                                   :state-dependencies {}}])
                      (set-parent-selection false))}
         [:span.icon>i.fas.fa-trash]]]
       [:div.control
        (let [show-results (or (and parent-query (not (str/blank? parent-query)))
                               parent-selection)]
          [:div.field.has-addons {:style {:display "flex"
                                          :align-items "center"}}
           [:div.control.has-icons-left.is-expanded
            [:span.icon.is-left>i.fas.fa-magnifying-glass]
            [:input.input {:value parent-query
                           :type "search"
                           :on-change #(set-parent-query (.. % -target -value))
                           :placeholder "Search for ID like, 123, or construct text"}]]
           [:div.dropdown.is-right {:class (when show-results
                                             "is-active")}
            [:div.dropdown-trigger
             [:button.button
              {:aria-haspopup "true"
               :aria-controls "dropdown-menu"
               :on-click #(set-parent-selection (not parent-selection))}
              [:span.icon.is-small>i.fas.fa-angle-down {:aria-hidden "true"}]]]
            [:div.dropdown-menu {:role "menu"}
             [:div.dropdown-content
              (let [analyses (map (comp first second) all-analyses)
                    family (if this-id
                             (analysis/find-family-ids this-id analyses)
                             #{})
                    options (remove #(contains? family (:construct-id %)) analyses)]
                (for [{:keys [construct-id
                              construct]}
                      (filter
                       (fn [analysis]
                         (utils/match-search-query
                          parent-query
                          (fn [query-word]
                            (or (utils/str-includes-icase? (:construct analysis)
                                                           query-word)
                                (utils/str-includes-icase? (analysis.profile/format-analysis-id (:construct-id analysis))
                                                           query-word)))))
                       (sort-by :construct-id options))]
                  [:a.dropdown-item {:key (str construct-id)
                                     :on-click (fn [_]
                                                 (rf/dispatch [::update-data {:parent-id construct-id}])
                                                 (set-parent-query nil))}
                   (analysis.profile/format-analysis-id construct-id)
                   [:span.ml-2 construct]]))]]]])])]))

(defn Construct [construct validation-errors]
  [:div.field
   [:label.has-text-weight-bold "Analytical construct"]
   [:div.control
    [:f> expanding-textarea {:auto-focus true
                             :value construct
                             :class (when (:construct validation-errors) "is-danger")
                             :on-change #(rf/dispatch [::update-data {:construct (.. % -target -value)}])
                             :placeholder "Enter analytical construct"
                             :rows 1}]]])

(defn ImmediateChildAnalyses [sub-analyses states on-view-analysis]
  (when (seq sub-analyses)
    [:div.field.mt-4.pt-2
     [:label.has-text-weight-bold "Analysis informs sub-analysis"]
     [:div.analysis-list
      (map (fn [{:keys [construct-id construct] :as sub-analysis}]
             (let [sub-states (:states sub-analysis)
                   sub-state-dependencies (:state-dependencies sub-analysis)]
               [:div.mb-1.analysis-list
                {:key (str "sub-analysis-" construct-id)}
                [:div.level.mb-2.analysis-list-row.clickable-row
                 [:span
                  [:span.has-text-info.mr-2 (analysis.profile/format-analysis-id construct-id)]
                  construct]
                 [:button.button.is-secondary.is-rounded.is-small
                  {:title "View analysis"
                   :on-click #(on-view-analysis construct-id nil false)}
                  "View"]]
                [:<> (map #(analysis.profile/state-dependency {:relative-to :child
                                                       :child-states sub-states
                                                       :parent-states states
                                                       :dependency %})
                          sub-state-dependencies)]]))
           sub-analyses)]]))

(defn RelatesTo [relates-to]
  [:div.field.mt-4.pt-2
   [:label.has-text-weight-bold "Analysis relates to"]
   (map-indexed (fn [index relation]
                  [:div.level.my-1 {:key (str "relation-" index)}
                   [:input.input
                    {:value relation
                     :on-change #(rf/dispatch [::update-data
                                               {:relates-to (assoc relates-to index (.. % -target -value))}])
                     :placeholder "Other areas that this analysis may relate to"}]
                   [:button.button.is-inverted.is-info
                    {:title "Remove this relation"
                     :on-click #(rf/dispatch [::update-data
                                              {:relates-to (vec (drop-nth index relates-to))}])}
                    [:span.icon>i.fas.fa-trash]]])
                relates-to)
   [:div.level.mt-1
    [:div.level-left]
    [:div.level-right>button.button.is-info.is-small.is-rounded
     {:on-click #(rf/dispatch [::update-data
                               {:relates-to (vec (conj relates-to ""))}])}
     "Add new relates to"]]])

(defn Excludes [excludes]
  [:div.field.mt-4.pt-2
   [:label.has-text-weight-bold "Analysis excludes"]
   (map-indexed (fn [index exclusion]
                  [:div.level.my-1 {:key (str "exclusion-" index)}
                   [:input.input
                    {:value exclusion
                     :on-change #(rf/dispatch [::update-data
                                               {:excludes (assoc excludes index (.. % -target -value))}])
                     :placeholder "Used to establish distinct boundaries between different concepts with strong linguistic associations (ie, between encryption at rest and encryption in transit)"}]
                   [:button.button.is-inverted.is-info
                    {:title "Remove this exclusion"
                     :on-click #(rf/dispatch [::update-data {:excludes (vec (drop-nth index excludes))}])}
                    [:span.icon>i.fas.fa-trash]]])
                excludes)
   [:div.level.mt-1
    [:div.level-left]
    [:div.level-right>button.button.is-info.is-small.is-rounded {:on-click #(rf/dispatch [::update-data {:excludes (vec (conj excludes ""))}])}
     "Add new excludes"]]])

(defn Commentary [comment]
  [:div.field.mt-4.pt-2
   [:label.has-text-weight-bold "Commentary on analysis"]
   [:div.control
    [:f> expanding-textarea
     {:value comment
      :on-change #(rf/dispatch [::update-data
                                {:comment (let [value (.. % -target -value)]
                                            (if (str/blank? value)
                                              nil
                                              value))}])
      :placeholder "Additional information about the analysis that doesn't fit in the above categories"
      :rows 1}]]])

(defn record-structured-analysis-form [{:keys [on-view-analysis]}]
  (let [{:keys [construct-id construct states categories relates-to excludes comment parent-id] :as structured-analysis} @(rf/subscribe [::data])
        id->category @(rf/subscribe [::categories])

        parent-analysis @(rf/subscribe [::analysis parent-id])
        sub-analyses @(analysis.db/sub-analyses* construct-id)

        validation-errors (validate structured-analysis)]
    [:div.column
     [Construct construct validation-errors]

     [Commentary comment]

     [Categories id->category categories]

     [:f> ParentSelection parent-analysis construct-id]
     [PossibleStates structured-analysis parent-analysis]
     [ImmediateChildAnalyses sub-analyses states on-view-analysis]

     [RelatesTo relates-to]
     [Excludes excludes]]))

(defn record-structured-analysis-modal [{:keys [on-close ctx]}]
  (let [{:keys [mode on-view-analysis existing-structured-analysis]} ctx

        structured-analysis @(rf/subscribe [::data])
        saving? @(rf/subscribe [::is-saving])

        validation-errors (validate structured-analysis)
        invalid? (has-validation-errors validation-errors)
        dirty? (if existing-structured-analysis
                 (= existing-structured-analysis structured-analysis)
                 false)]
    [:div.card
     [:div.card-header.has-background-info.has-text-white
      [:title.card-header-title.has-text-white.is-size-4
       (case mode
         :create "Record structured analysis"
         :edit (str "Update structured analysis "
                    (-> structured-analysis
                        :construct-id
                        analysis.profile/format-analysis-id))
         nil)]
      [:button.card-header-icon {:on-click on-close}
       [:span.icon [:i.fas.fa-xmark]]]]
     [:div.card-content.p-4 {:style {:height "75vh" :overflow-y "scroll"}}
      [:div.is-flex {:style {:width "100%" :height "100%" :overflow-y "scroll"}}
       [:f> record-structured-analysis-form {:on-view-analysis on-view-analysis}]]]
     [:footer.card-footer
      [:div.card-footer-item
       [:button.button.is-info.is-rounded
        {:disabled (or invalid? dirty?)
         :title (cond
                  invalid?
                  "Validation errors detected, clear them to be able to create structured analysis"

                  dirty?
                  "No changes detected. Make changes to be able to create a new version of structured analysis"

                  :else (case mode
                          :create "Create a new structured analysis"
                          :edit "Create a new version of structured analysis"))
         :class (when saving? "is-loading")
         :on-click #(rf/dispatch [::create-structured-analysis mode])}
        (case mode
          :create "Record structured analysis"
          :edit "Update structured analysis")]]]]))

(rf/reg-event-fx
 ::show-record-modal
 (fn [_ [_ structured-analysis]]
   {:fx [[:dispatch [::update-data
                     structured-analysis]]
         [:dispatch [::ui/push-modal
                     {:component #'record-structured-analysis-modal
                      :on-close #(rf/dispatch [::clear-data])
                      :ctx {:mode :edit
                            :existing-structured-analysis structured-analysis
                            :on-view-analysis (fn [construct-id version-id]
                                                (rf/dispatch [::view-structured-analysis/show-view-modal construct-id version-id]))}
                      :content-props {:style {:min-width "75vw" :max-height "90vh" :padding 0}}}]]]}))
